"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
const Avatar_1 = __importDefault(require("@material-ui/core/Avatar"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const ChromeReaderMode_1 = __importDefault(require("@material-ui/icons/ChromeReaderMode"));
const react_router_dom_1 = require("react-router-dom");
const styles = (theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.common.white,
    },
    menuButton: {
        color: theme.palette.text.primary,
    },
    active: {
        fontWeight: 900,
    },
    listItems: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'space-between',
    },
    navBorder: {
        borderBottom: `solid 1px ${theme.palette.secondary.dark}`,
        boxShadow: '0',
    },
    avatar: {
        cursor: 'pointer',
        fontSize: '16px',
    },
});
function DenseAppBar(props) {
    const { authActionSubmit, classes, links, loggedIn, userInitials, newsLetterOrigin, onNewsLetterClick } = props;
    const [currentPath, setCurrentPath] = react_1.useState('');
    const history = react_router_dom_1.useHistory();
    react_1.useEffect(() => {
        setCurrentPath(typeof window !== 'undefined' ? window.location.pathname : '');
    });
    const orsNewsLetterRedirection = () => {
        if (loggedIn) {
            history.push({
                pathname: `/edit-user-profile`,
            });
        }
        else {
            history.push({
                pathname: '/newsletter-signup',
            });
        }
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(AppBar_1.default, { position: "static", color: "inherit", className: classes.navBorder, elevation: 0 },
            react_1.default.createElement(core_1.Container, { maxWidth: "lg" },
                react_1.default.createElement(Toolbar_1.default, { disableGutters: true },
                    react_1.default.createElement(Typography_1.default, { variant: "h6", color: "inherit" }, "Online Review System"),
                    react_1.default.createElement(Divider_1.default, { orientation: "vertical", flexItem: true, light: true, variant: "middle", color: "secondary" }),
                    react_1.default.createElement("div", { className: classes.listItems },
                        react_1.default.createElement("div", null, links.map((link, i) => {
                            if (link.visible || typeof link.visible !== 'boolean') {
                                return (react_1.default.createElement(react_1.default.Fragment, { key: i }, link.onClick ? (react_1.default.createElement(Button_1.default, { color: "inherit", onClick: () => link.onClick(), className: clsx_1.default(classes.menuButton, link.value === currentPath && classes.active) }, link.title)) : (react_1.default.createElement(Button_1.default, { color: "inherit", href: link.value, className: clsx_1.default(classes.menuButton, link.value === currentPath && classes.active) }, link.title))));
                            }
                        })),
                        react_1.default.createElement(core_1.Box, null, newsLetterOrigin === 'website' ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(Button_1.default, { variant: 'outlined', endIcon: react_1.default.createElement(ChromeReaderMode_1.default, null), style: { marginRight: '1rem', fontWeight: 'bolder' }, onClick: () => onNewsLetterClick() }, "Newsletter"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(Button_1.default, { onClick: orsNewsLetterRedirection, variant: 'outlined', endIcon: react_1.default.createElement(ChromeReaderMode_1.default, null), style: { marginRight: '1rem', fontWeight: 'bolder' } }, "Newsletter"))))),
                    loggedIn && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Avatar_1.default, { className: classes.avatar, onClick: () => props.onUserInitialClick() }, userInitials),
                        react_1.default.createElement(Divider_1.default, { orientation: "vertical", flexItem: true, light: true, variant: "middle", classes: { root: classes.divider } }))),
                    react_1.default.createElement(Button_1.default, { color: "inherit", onClick: authActionSubmit }, loggedIn ? 'Logout' : 'Login'))))));
}
DenseAppBar.propTypes = {
    authActionSubmit: prop_types_1.default.func.isRequired,
    classes: prop_types_1.default.object.isRequired,
    links: prop_types_1.default.arrayOf(prop_types_1.default.any),
    loggedIn: prop_types_1.default.bool.isRequired,
    userInitials: prop_types_1.default.string,
    onUserInitialClick: prop_types_1.default.func,
    newsLetterOrigin: prop_types_1.default.any,
    onNewsLetterClick: prop_types_1.default.any,
};
exports.default = styles_1.withStyles(styles)(DenseAppBar);
